document
  .getElementById("delivery-app-overlay")
  .addEventListener("click", function () {
    document.getElementById("delivery-app-root").classList.remove("hidden");
  });
// check click out side delivery-app-root to close
document.addEventListener("click", function (e) {
  var element = document.getElementById("delivery-app-root");
  console.log(e.target);
  if (
    e.target !== element &&
    element.contains(e.target) === false &&
    e.target !== document.getElementById("delivery-app-overlay")
    && e.target !== document.body
  ) {
    element.classList.add("hidden");
  }
});

// DELEGATE ON CHANGE EVENT
document.addEventListener("change", function (e) {
  var data = {
    customFields: [
      {
        name: "delivery-date-time",
        value: jQueryOTD(".uiDeliveryDateVal").val() + " " + e.target.value,
      },
      {
        name: "Delivery Date",
        value: jQueryOTD(".uiDeliveryDateVal").val(),
      },
      {
        name: "Delivery Time",
        value: e.target.value,
      },
      {
        name: "Dlivery Day",
        value: jQueryOTD(".uiDeliveryDayVal").val(),
      }
    ]
  }
  if (e.target.matches(".iw-otd-deliveryTime")) {
    spark.updateCart(data, () => {
      console.log("done");
    });
  }
});
